module.exports = __webpack_public_path__ + "static/media/inbox.65900c66.svg";